import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { useForm } from "react-hook-form";
import { useEffect } from "react";
import cookie from "js-cookie";
import userPlaceholder from "../../assets/images/placeholder.jpg";
import { handleImage } from "../../helpers/functions";
import { toast } from "react-toastify";
import axios from "axios";

const TeamModal = ({
	showModal,
	handleCloseModal,
	modalType,
	selectedTeamMember,
	loading,
	setLoading,
	onStart,
}) => {
	const {
		register,
		handleSubmit,
		reset,
		formState: { errors },
	} = useForm();

	const [memberImage, setMemberImage] = useState("");

	const mainHandleImageUpload = event => {
		const file = event.target.files[0];
		if (!file) return;

		const formData = new FormData();
		formData.append("file", file);

		axios
			.post(`${process.env.REACT_APP_API_URL}/upload`, formData, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
					"Content-Type": "multipart/form-data",
				},
			})
			.then(function (res) {
				const uploadedPath = res.data.data.file.path;

				setMemberImage(handleImage(uploadedPath));
				toast.success("تم رفع الصورة بنجاح!");
			})
			.catch(function (err) {
				console.log(err);
			});
	};

	useEffect(() => {
		if (modalType === "edit") {
			reset({
				name: selectedTeamMember?.name,
				description: selectedTeamMember?.description,
			});
			setMemberImage(handleImage(selectedTeamMember?.image));
			// console.log(selectedTeamMember , 'image tet')
		} else {
			reset({
				name: "",
				description: "",
			});
			setMemberImage("");
		}
	}, [selectedTeamMember, reset]);

	const handleSubmitForm = data => {
		console.log("data", data);

		if (!data.name || !data.description || !memberImage) {
			return toast.error("جميع البيانات مطلوبة");
		}

		data.image = memberImage;

		if (modalType === "add") {
			axios
				.post(
					`${process.env.REACT_APP_API_URL}/pages/team-1/sections`,
					{
						section: data,
					},
					{
						headers: {
							Authorization: `Bearer ${cookie.get("token")}`,
							Accept: "application/json",
						},
					}
				)
				.then(function (response) {
					if (response?.data?.success) {
						toast.success("تم اضافة العضو بنجاح!");
						setLoading(false);
						handleCloseModal()
                         onStart();
					}
				})
				.catch(function (error) {
					toast.error("خطأ، برجاء المحاولة مره اخرى!");
					setLoading(false);
				});
		} else if (modalType === "edit") {
			axios
				.put(
					`${process.env.REACT_APP_API_URL}/pages/team-1/sections/${selectedTeamMember?.slug}`,
					{
						section: data,
					},
					{
						headers: {
							Authorization: `Bearer ${cookie.get("token")}`,
							Accept: "application/json",
						},
					}
				)
				.then(function (response) {
					if (response?.data?.success) {
						toast.success("تم اضافة العضو بنجاح!");
						setLoading(false);
						handleCloseModal()
                         onStart();
					}
				})
				.catch(function (error) {
					toast.error("خطأ، برجاء المحاولة مره اخرى!");
					setLoading(false);
				});
		}
	};

	return (
		<Modal isOpen={showModal} toggle={handleCloseModal}>
			<ModalHeader>
				{modalType === "add" ? "اضافة عضو جديد" : "تعديل بيانات العضو"}
				<button className="close" onClick={handleCloseModal} type="button">
					&times;
				</button>
			</ModalHeader>
			<ModalBody>
				<form onSubmit={handleSubmit(handleSubmitForm)}>
					<div className="form-item">
						<label htmlFor="picture">البانر</label>
						<input
							type="file"
							id="picture"
							onChange={e => mainHandleImageUpload(e)}
						/>
						<input type="hidden" />
						<img
							style={{ width: "100px", height: "100px", objectFit: "cover" }}
							src={memberImage ? memberImage : userPlaceholder}
							alt="preview"
							className="imagePreview"
						/>
					</div>

					<div className="mb-3">
						<label className="form-label">الاسم باللغة العربية</label>
						<input
							{...register("name.ar", {
								required: "هذا الحقل مطلوب",
							})}
							className="form-control"
							dir="rtl"
						/>
						{errors?.name?.ar && (
							<p className="text-danger mt-1">{errors.name.ar.message}</p>
						)}
					</div>

					<div className="mb-3">
						<label className="form-label">الاسم باللغة الإنجليزية</label>
						<input
							{...register("name.en", {
								required: "هذا الحقل مطلوب",
							})}
							className="form-control"
						/>
						{errors?.name?.en && (
							<p className="text-danger mt-1">{errors.name.en.message}</p>
						)}
					</div>

					<div className="mb-3">
						<label className="form-label">الوصف باللغة العربية</label>
						<textarea
							{...register("description.ar", {
								required: "هذا الحقل مطلوب",
							})}
							className="form-control"
							dir="rtl"
							style={{ resize: "none", height: "120px" }}
						/>
						{errors?.description?.ar && (
							<p className="text-danger mt-1">
								{errors.description.ar.message}
							</p>
						)}
					</div>

					<div className="mb-3">
						<label className="form-label">الوصف باللغة الإنجليزية</label>
						<textarea
							{...register("description.en", {
								required: "هذا الحقل مطلوب",
							})}
							className="form-control"
							style={{ resize: "none", height: "120px" }}
						/>
						{errors?.description?.en && (
							<p className="text-danger mt-1">
								{errors.description.en.message}
							</p>
						)}
					</div>

					<button type="submit" className="btn btn-secondary">
						{modalType == "add" ? "اضافة" : "تعديل"}
					</button>
				</form>
			</ModalBody>
		</Modal>
	);
};

export default TeamModal;
